import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { instance } from "../../api";
import "./Pagination.css"
import Pagination from "./Pagination";
export default function Clients() {
  const [clientDialog, setClientDialog] = useState(false);
  const [deleteClientDialog, setDeleteClientDialog] = useState(false);
  const [addclientDialog, setAddclientDialog] = useState(false);

  const options = ["false", "true"];
  const [submitted, setSubmitted] = useState(false);
  const [clients, setClients] = useState();

  const [globalFilter] = useState(null);
  const [filteredClients, setFilteredClients] = useState([]); // Liste filtrée
  const [searchText, setSearchText] = useState(""); // Texte de recherche
  const toast = useRef(null);
  const toastAdd = useRef(null);
  const toastEdit = useRef(null);
  const dt = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [dataPerPage, setDataPerPage] = useState(100);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  const totalPages = Math.ceil((filteredClients?.length || 0) / dataPerPage);
  const lastIndex = currentPage * dataPerPage;
  const firstIndex = lastIndex - dataPerPage;
  const currentData = filteredClients?.slice(firstIndex, lastIndex) || [];
  const [client, setClient] = useState({
    id_client_gexpertise: '',
    nom: '',
    archive: false,  // Assuming 'false' as the default
  });
  
  
  useEffect(() => {
    instance
      .get(`/api/clients/`)
      .then((result) => {
        setClients(result.data);
        setFilteredClients(result.data);
       
      });
  }, []);

// Gestion du changement dans le champ de recherche
const handleSearchChange = (e) => {
  const value = e.target.value;
  setSearchText(value);

  if (value.trim() === "") {
    setFilteredClients(clients); // Réinitialisation si le champ est vide
  } else {
    const filtered = clients.filter((client) =>
      client.nom.toLowerCase().includes(value.toLowerCase())||
      client.id_client_gexpertise.toLowerCase().includes(value.toLowerCase())||
      (client.archive && client.archive.toString().toLowerCase().includes(value.toLowerCase()))
  );
    setFilteredClients(filtered); // Mise à jour avec les résultats filtrés
  }
};
const addClient = () => {
  setSubmitted(true);
  if (!client.id_client_gexpertise || !client.nom || client.archive === undefined) {
    // Validate that all required fields are present before sending the request
    toastAdd.current.show({
      severity: "error",
      summary: "Erreur",
      detail: "Tous les champs sont obligatoires.",
      life: 3000,
    });
    return;  // Stop the function if validation fails
  }

  // Make sure the data is correct
  console.log(client);

  instance.post(`/api/clients/add/client`, {
    id_client_gexpertise: client.id_client_gexpertise,
    nom: client.nom,
    archive: client.archive // archive should be a boolean
  })
  .then(() => {
    // Update the state immediately to reflect the newly added client
    setClients(prevClients => [...prevClients, client]);
    setFilteredClients(prevFiltered => [...prevFiltered, client]);

    setAddclientDialog(false);
    toastAdd.current.show({
      severity: "success",
      summary: "Ajout du client",
      detail: "Client ajouté avec succès.",
      life: 3000,
    });
    setClient({
      idClientGexpertise: '',
      nom: '',
      archive: false, // Default archive value
    });
    setSubmitted(false); // reset the submission state 
  })
  .catch((error) => {
    console.error("Erreur lors de l'ajout du client:", error);
    toastAdd.current.show({
      severity: "error",
      summary: "Erreur",
      detail: "Impossible d'ajouter le client.",
      life: 3000,
    });
  });
};


const confirmDeleteClient = (client) => {
  setClient(client);  // Save the client to be deleted in the state
  setDeleteClientDialog(true);  // Show the delete confirmation dialog
};

const deleteClient = () => {
  // Ensure you have the correct client ID
  const id = client.id_client_gexpertise;
  console.log(id);  // Debug the client ID

  if (!id) {
      console.error("Client ID is undefined");
      return;
  }

  // Call the delete API using Axios
  instance.delete(`/api/clients/delete/${id}`)
      .then((response) => {
          // Filter out the deleted client from the clients array
          const updatedClients = clients.filter((c) => c.id_client_gexpertise !== id);
          setClients(updatedClients);
          setFilteredClients(updatedClients); // Update the filtered list

          // Show success toast
          toast.current.show({
              severity: "success",
              summary: "Succès",
              detail: "Le client a été supprimé avec succès",
              life: 3000,
          });

          // Close the dialog
          setDeleteClientDialog(false);
      })
      .catch((error) => {
          console.error("Error deleting client:", error.response?.data || error.message);
          toast.current.show({
              severity: "error",
              summary: "Erreur",
              detail: "Erreur lors de la suppression du client",
              life: 3000,
          });
      });
};

  const hideDeleteClientDialog = () => {
    setDeleteClientDialog(false);
  };
  const deleteClientDialogFooter = (
    <React.Fragment>
      <Button
        label="Non"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteClientDialog}
      />
      <Button
        label="Oui"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteClient}
      />
    </React.Fragment>
  );
  const editClient = (client) => {
    setClient({ ...client });
    setClientDialog(true);
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded succesBtn mr-2"
          onClick={() => editClient(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded succesBtn"
          onClick={() => confirmDeleteClient(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="table-header">
      <h5 className="mx-0 my-1">Liste des clients </h5>
      <span className="p-input-icon-right">
        <InputText
          type="search"
          value={searchText}
          onChange={handleSearchChange}
          placeholder=" Chercher..."
        />
        <i className="pi pi-search" />
      </span>
      <Button
          label="Créer"
          icon="pi pi-plus"
          className="addBtn succesBtn"
          style={{ color: '#fff', backgroundColor: '#970121' }}
          onClick={()=> setAddclientDialog(true)}
        />
    </div>
  );
  const hideDialog = () => {
    setSubmitted(false);
    setClientDialog(false);
  };
  const saveClient = () => {
    // PUT client WS

    instance
      .put(`/api/clients/edit/${client.id_client_gexpertise}`, {
        idClientGexpertise: client.id_client_gexpertise,
        nom: client.nom,
        archive:JSON.parse(client.archive)
      })
      .then(() => { setClientDialog(false);
        // Update the clients state with the edited client
      setClients(prevClients => 
        prevClients.map(c => 
          c.id_client_gexpertise === client.id_client_gexpertise ? { ...client } : c
        )
      );

      // Also update the filteredClients if necessary
      setFilteredClients(prevClients => 
        prevClients.map(c => 
          c.id_client_gexpertise === client.id_client_gexpertise ? { ...client } : c
        )
      );
      
        toast.current.show({
          severity: "success",
          summary: "Modification du client",
          detail: "Client Modifié",
          life: 3000,
        });
      });   
  };



  const clientDialogFooter = (
    <React.Fragment>
      <Button
        label="Annuler"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Enregistrer"
        icon="pi pi-check"
        className="p-button-text"
        onClick={saveClient}
      />
    </React.Fragment>
  );
  const onInputChange = (e, name) => {
    const val = e.target.value;
    setClient((prevClient) => ({ ...prevClient, [name]: val }));
};
  const onArchiveChange = (e) => {
    setClient((prevClient) => ({ ...prevClient, archive: e.value === "true" }));
  };
  const archiver = (rowData) => {
    const archive = rowData.archive;
  
    return String(archive);
  };
const AddclientDialogFooter=(
  <React.Fragment>
  <Button
    label="Annuler"
    icon="pi pi-times"
    className="p-button-text"
    onClick={()=>setAddclientDialog(false)}
  />
  <Button
    label="Enregistrer"
    icon="pi pi-check"
    className="p-button-text"
    onClick={addClient}
  />
</React.Fragment>
)
  return (
    <div className="datatable-crud">
      <Toast ref={toast} />
      <Toast ref={toastAdd} />
      <Toast ref={toastEdit} />

   
      <DataTable
        ref={dt}
        value={currentData}
        dataKey="id"
        emptyMessage="Client introuvable"
        // paginator
        // rows={10}
        // rowsPerPageOptions={[25, 50]}
        // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        // currentPageReportTemplate="Voir  {first} à {last} de  {totalRecords} utilisateurs"
        globalFilter={globalFilter}
        header={header}
        responsiveLayout="scroll"
        className="crudTable"
        scrollable  scrollHeight="500px" 
      >
        <Column
          field="id_client_gexpertise"
          header="ID Clients"
          style={{ minWidth: "8rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">ID Clients </span>{rowData.id_client_gexpertise}
            </div>
          )}
          
        ></Column>
        <Column field="nom" header="Nom" style={{ minWidth: "5rem" }}
        body={(rowData) => (
          <div className="table-data">
          <span className="mobile-header">Nom </span>{rowData.nom}
          </div>
        )}></Column>
        <Column
         
          header="Archive"
          style={{ minWidth: "5rem" }}
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Archive </span>
              {archiver(rowData)}
            </div>
          )}
        ></Column>
        <Column
          body={actionBodyTemplate}
          exportable={false}
          header="Actions"
          style={{ minWidth: "3rem" }}
        ></Column>
      </DataTable>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        dataPerPage={dataPerPage}
        setDataPerPage={setDataPerPage}
        handlePageChange={handlePageChange}
      />
      <Dialog
        visible={clientDialog}
        style={{ width: "450px" }}
        header="Détail du client"
        modal
        className="p-fluid"
        footer={clientDialogFooter}
        onHide={hideDialog}
      >
        {client && (
          <div>
            <div className="field">
              <label htmlFor="idClientGexpertise">id Client</label>
              <InputText
                id="idClientGexpertise"
                value={client.id_client_gexpertise}
                nChange={(e) => onInputChange(e, 'idClientGexpertise')}
                disabled
                required
              />
            </div>

            <div className="field">
              <label htmlFor="name">Name</label>
              <InputText
                id="name"
                value={client.nom}
                onChange={(e) => onInputChange(e, "nom")}
                required
                autoFocus
                className={classNames({
                  "p-invalid": submitted && !client.nom,
                })}
              />
              {submitted && !client.nom && (
                <small className="p-error">le nom requis.</small>
              )}
            </div>

            <div className="field">
              <label className="mb-3">Archivé</label>
              <div className="formgrid grid">
                <div className="field-radiobutton col-6">
                  <SelectButton
                    value={String(client.archive)}
                    onChange={onArchiveChange}
                    options={options}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Dialog>
      <Dialog
        visible={addclientDialog}
        style={{ width: "450px" }}
        header="Ajouter un client"
        modal
        className="p-fluid"
        footer={AddclientDialogFooter}
        onHide={(e)=>setAddclientDialog(false)}
      >
      
          <div>
            <div className="field">
              <label htmlFor="idClientGexpertise">id Client</label>
              <InputText
                id="id_client_gexpertise"
                value={client.id_client_gexpertise}
                onChange={(e) => onInputChange(e, 'id_client_gexpertise')}              
                required
              />
            </div>

            <div className="field">
              <label htmlFor="name">Name</label>
              <InputText
                id="name"
                value={client.nom}
                onChange={(e) => onInputChange(e, "nom")}
                required
                className={classNames({
            "p-invalid": submitted && !client.nom,
          })}
          />
              {submitted && !client.nom && (
                <small className="p-error">le nom requis.</small>
              )}
            </div>

            <div className="field">
              <label className="mb-3">Archivé</label>
              <div className="formgrid grid">
                <div className="field-radiobutton col-6">
                  <SelectButton
                    value={String(client?.archive || "false")}
                    onChange={onArchiveChange}
                    options={options}
                  />
                </div>
              </div>
            </div>
          </div>
        
      </Dialog>
      <Dialog
        visible={deleteClientDialog}
        style={{ width: "450px" }}
        header="Confirmer la suppression"
        modal
        footer={deleteClientDialogFooter}
        onHide={hideDeleteClientDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {client && (
            <span>
            Voulez-Vous supprimer <b>{client.nom}</b>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
}
